import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-57271388")

_pushScopeId("data-v-57271388")
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "shop-name" }
const _hoisted_3 = { class: "navigation" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_menu = _resolveComponent("ion-menu")

  return (_openBlock(), _createBlock(_component_ion_menu, {
    side: "start",
    "menu-id": "first",
    "content-id": "main"
  }, {
    default: _withId(() => [
      _createVNode(_component_ion_toolbar, null, {
        default: _withId(() => [
          _createVNode(_component_ion_button, {
            size: "small",
            fill: "transparent",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.menuController.close()))
          }, {
            default: _withId(() => [
              _createVNode(_component_ion_icon, {
                slot: "icon-only",
                class: "close-icon",
                icon: "/assets/icons/close.svg"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("p", { innerHTML: _ctx.shopName }, null, 8, ["innerHTML"]),
          _createVNode("div", {
            class: ["pause-light", { paused: _ctx.isPaused }]
          }, null, 2)
        ]),
        _createVNode("a", {
          class: "pause-button",
          innerHTML: _ctx.pauseStateText(_ctx.isPaused),
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.togglePauseState()))
        }, null, 8, ["innerHTML"]),
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
            return (_openBlock(), _createBlock("a", {
              key: item.target,
              class: "navigation-item",
              innerHTML: item.label,
              onClick: $event => (_ctx.goTo(item.target))
            }, null, 8, ["innerHTML", "onClick"]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ]),
    _: 1
  }))
})